define(["./entry"],(function(n){"use strict";return{createEntry:function(e,t,r){return new n(e,t,r)}}}));